module.exports = __webpack_public_path__ + "static/media/applicationDevelopment-min.37f43e21.jpg";